/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SummaryBankSourceResponse } from './SummaryBankSourceResponse';
import {
    SummaryBankSourceResponseFromJSON,
    SummaryBankSourceResponseFromJSONTyped,
    SummaryBankSourceResponseToJSON,
    SummaryBankSourceResponseToJSONTyped,
} from './SummaryBankSourceResponse';

/**
 * 
 * @export
 * @interface SummaryBankAccountResponse
 */
export interface SummaryBankAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof SummaryBankAccountResponse
     */
    title?: string;
    /**
     * 
     * @type {Array<SummaryBankSourceResponse>}
     * @memberof SummaryBankAccountResponse
     */
    sources?: Array<SummaryBankSourceResponse>;
}

/**
 * Check if a given object implements the SummaryBankAccountResponse interface.
 */
export function instanceOfSummaryBankAccountResponse(value: object): value is SummaryBankAccountResponse {
    return true;
}

export function SummaryBankAccountResponseFromJSON(json: any): SummaryBankAccountResponse {
    return SummaryBankAccountResponseFromJSONTyped(json, false);
}

export function SummaryBankAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryBankAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(SummaryBankSourceResponseFromJSON)),
    };
}

export function SummaryBankAccountResponseToJSON(json: any): SummaryBankAccountResponse {
    return SummaryBankAccountResponseToJSONTyped(json, false);
}

export function SummaryBankAccountResponseToJSONTyped(value?: SummaryBankAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(SummaryBankSourceResponseToJSON)),
    };
}

